export default "__VITE_ASSET__f991392c__"